import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { Role } from 'src/app/lem/models/common/role';
import { Person } from 'src/app/lem/models/person/person';
import { DepartmentsService } from '../../service/departments.service';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { CompanyDepartmentMember, RequestCompanyDepartmentMember } from 'src/app/lem/models/departments/member/member';
import { CompaniesDepartment } from 'src/app/lem/models/departments/departments';
import { ACTION_TRANSFER } from '../../constants/constants';

@Component({
  selector: 'app-modal-member',
  templateUrl: './modal-member.component.html',
  styleUrls: ['./modal-member.component.css']
})
export class ModalMemberComponent implements OnInit {

  form : FormGroup;
  departmentSelected:CompaniesDepartment;
  personSelected: Person;
  roleSelected:Role;
  memberSelected:CompanyDepartmentMember;
  roles: Role[];
  isInChargeOf : boolean;
  action : string;
  listMembersID : string[] = [];
  departments: CompaniesDepartment[];
  departmentSelectedTo : CompaniesDepartment;

  request : RequestCompanyDepartmentMember = {
    personId:null,
    roleId:null,
    isInChargeOf:false,
    validFrom: null,
    validTo: null
  }

  constructor(
    private formBuilder : FormBuilder,
    private modalRef : DialogRef,
    private departmentsService : DepartmentsService,
    private dialogConfig : DialogConfig,
    private dialogRef : DialogRef
    ) { }

  ngOnInit() {
    this.retrieveInfo();
    this.initForm();
  }

  private retrieveInfo() {
    this.departmentSelected = this.dialogConfig.data.departmentSelected;
    this.memberSelected = this.dialogConfig.data.member;
    this.roles = this.dialogConfig.data.roles;
    this.action = this.dialogConfig.data.action;
    this.listMembersID = this.dialogConfig.data.listMembersID;
    this.departments = this.dialogConfig.data.departments;
    if (this.memberSelected) {
      this.isInChargeOf = this.memberSelected.isInChargeOf;
      this.personSelected = this.memberSelected.person;
      this.roleSelected = this.memberSelected.role;
    }
  }

  private initForm() {

    if(this.action === ACTION_TRANSFER){
      this.form = this.formBuilder.group({
        department: [this.departmentSelectedTo, Validators.required]
      });
    } else {
      this.form = this.formBuilder.group({
        person: [this.personSelected, Validators.required],
        role: [this.roleSelected, Validators.required],
        isInChargeOf: [this.isInChargeOf, Validators.required]
      });
    }
    
  }

  retrievePerson(person:Person){
    this.personSelected = person;
    this.initForm();
  }

  retrieveRole(role:Role){
    this.roleSelected = role;
    this.initForm();
  }

  onSave(){
    this.request.personId = this.personSelected.id;
    this.request.roleId = this.roleSelected.id;
    this.request.isInChargeOf = this.isInChargeOf;
    this.dialogRef.close({data: this.request, member: this.memberSelected , action:this.action , departmentSelectedTo: this.departmentSelectedTo});
  }

  formReset(){
    this.retrieveInfo();
    this.initForm();
  }

  deletePerson(){
    this.personSelected = undefined;
    this.initForm();
  }

  deleteRole(){
    this.roleSelected = undefined;
    this.initForm();
  }

  changeDepartment(departmentSelectedTo : CompaniesDepartment){
    if(departmentSelectedTo){
      this.departmentSelectedTo = departmentSelectedTo;
    } else {
      this.departmentSelectedTo = undefined;
    }
    
  }

}
